module.exports = __webpack_public_path__ + "static/images/imgBg02.0dc12e6.png";